import React, { useEffect } from 'react';
import { Button } from '@carvana/core-helios-button';
import { datadogRum } from '@datadog/browser-rum';
import { AnalyticEvents } from '@constants/index';
import { Analytics } from '@services/analytics-service';
import { useRouter } from '../../providers/router';
import IssueSubmittedIcon from '../../../../assets/issue-submitted.svg';
import styles from '../../components/coverage-screen/coverage.module.css';

export const IssueSubmitted = () => {
  const { closeModal } = useRouter();

  useEffect(() => {
    Analytics.trackEvent(AnalyticEvents.sarCoverageScreenViewedIssueSubmitted);
    datadogRum.addAction(AnalyticEvents.sarCoverageScreenViewedIssueSubmitted);
  }, []);

  const handleOkClick = () => {
    closeModal();
  };

  return (
    <div className={styles['coverage']}>
      <div className={styles['coverage-contact']}>
        <img src={IssueSubmittedIcon} alt="Issue Submitted" />
        <div>Your issue is submitted</div>
        <p>We will email you within 48 hours with next steps.</p>
        <Button onClick={handleOkClick}>Ok</Button>
      </div>
    </div>
  );
};
